<template>
  <div class="mainWrapper">
    <div class="navbar-header">
      <a class="navbar-brand" href="#">
        <small>
          Powered by&nbsp;
          <img alt="Brand" class="mainLogo" :src="require('@/assets/img/CIC.png')" height="38" />
        </small>
      </a>
    </div>
  </div>

  <div class="container">
    <div class="success-left-section">
      <div class="asideBody">
        <h2>Submitting Your Survey...</h2>
        <h4>Hang tight! We're saving your responses securely.</h4>
        <div class="col-sm-12 text-center hideElement">
          <img :src="require('@/assets/img/asideImage/loader.gif')" style="width: 100%;" />
        </div>
      </div>
      <div class="asideFoot">
        <small>Thank you for your patience.</small><br />
        <div>
          <a class="btn fbBG"><i class="fab fa-facebook-square"></i></a>
          <a class="btn InstaBG"><i class="fab fa-instagram"></i></a>
          <a class="btn xBG"><i class="fab fa-twitter"></i></a>
          <a class="btn waBG"><i class="fab fa-whatsapp"></i></a>
        </div>
      </div>
    </div>

    <div class="success-right-section" style="height: calc(100vh - 101px); padding: 30px; overflow-y: auto;">
      <img alt="Loading" :src="require('@/assets/img/asideImage/loader.gif')" style="height: 280px;" />
      <p class="text-center mt-3">Almost there... Please do not close this page.</p>
    </div>
  </div>
</template>
